import SignalCellular0BarIcon from '@mui/icons-material/SignalCellular0Bar';
import SignalCellular1BarIcon from '@mui/icons-material/SignalCellular1Bar';
import SignalCellular2BarIcon from '@mui/icons-material/SignalCellular2Bar';
import SignalCellular4BarIcon from '@mui/icons-material/SignalCellular4Bar';

import type {QualityConfig, QualityLevel} from './types';

// ─── Bandwidth ────────────────────────────────────────────────────────────────

/** receiveBitRateAvailable = 100 Mbps is a sentinel (unconstrained channel). Cap before scoring. */
const BW_SENTINEL_CAP_KBPS = 10_000;

const BANDWIDTH_THRESHOLDS = {
    poorBelow: 300, // kbps
    fairBelow: 800, // kbps
} as const;

const ENCODE_BW_PERCENT_THRESHOLDS = {
    poorBelow: 10, // %
    fairBelow: 25, // %
} as const;

// ─── RTT ──────────────────────────────────────────────────────────────────────

const RTT_THRESHOLDS = {
    fairAbove: 150, // ms
    poorAbove: 400, // ms
} as const;

// ─── Video ────────────────────────────────────────────────────────────────────

const VIDEO_DROP_THRESHOLDS = {
    fairAbove: 3, // %
    poorAbove: 10, // %
} as const;

/** Delta per 2-second poll interval */
const VIDEO_PACKETS_LOST_THRESHOLDS = {
    fairAbove: 0, // any loss → fair
    poorAbove: 5,
} as const;

/** Delta per 2-second poll interval */
const VIDEO_PACKETS_CONCEALED_THRESHOLDS = {
    fairAbove: 100,
    poorAbove: 500,
} as const;

/** Delta per 2-second poll interval */
const VIDEO_PACKETS_REORDERED_THRESHOLDS = {
    fairAbove: 3,
    poorAbove: 10,
} as const;

// ─── Audio ────────────────────────────────────────────────────────────────────

/** Real-time, milliseconds (receiveNetworkJitter × 1000) */
const AUDIO_JITTER_THRESHOLDS = {
    fairAbove: 50, // ms
    poorAbove: 150, // ms
} as const;

/** Delta per 2-second poll interval */
const AUDIO_PACKETS_LOST_THRESHOLDS = {
    fairAbove: 0, // any loss → fair
    poorAbove: 3,
} as const;

/** Delta per 2-second poll interval */
const AUDIO_PACKETS_CONCEALED_THRESHOLDS = {
    fairAbove: 500,
    poorAbove: 2000,
} as const;

// ─── Display ──────────────────────────────────────────────────────────────────

const QUALITY_CONFIG: Record<QualityLevel, QualityConfig> = {
    good: {color: '#4caf50', label: 'Good', Icon: SignalCellular4BarIcon},
    fair: {color: '#ffc107', label: 'Fair', Icon: SignalCellular2BarIcon},
    poor: {color: '#f44336', label: 'Poor', Icon: SignalCellular1BarIcon},
    unknown: {color: '#9e9e9e', label: 'Connecting…', Icon: SignalCellular0BarIcon},
};

export {
    AUDIO_JITTER_THRESHOLDS,
    AUDIO_PACKETS_CONCEALED_THRESHOLDS,
    AUDIO_PACKETS_LOST_THRESHOLDS,
    BANDWIDTH_THRESHOLDS,
    BW_SENTINEL_CAP_KBPS,
    ENCODE_BW_PERCENT_THRESHOLDS,
    QUALITY_CONFIG,
    RTT_THRESHOLDS,
    VIDEO_DROP_THRESHOLDS,
    VIDEO_PACKETS_CONCEALED_THRESHOLDS,
    VIDEO_PACKETS_LOST_THRESHOLDS,
    VIDEO_PACKETS_REORDERED_THRESHOLDS,
};
